import { ChevronDoubleDownIcon, ChevronDoubleUpIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import { Checkbox, FormControl, ListItemText, MenuItem, Select } from "@material-ui/core";
import { handleProjectChange } from "./WorkLog3";

const WeekCard = (props) => {

    const {item,daysVisible,weekIndex,toggleDaysVisibility,datesData,getLogHoursValue,getCommentsValue,isEditable,isAdmin,handleCommentChange,handleHourChange,handleSubmit,timeSheet,setTimeSheet} = props;
    const exceedsWordLimit = (text) => {
      if (text) {
        const words = text.split("").length;
        return words > 25;
      }
      return false;
    };

  return (
    <div
      key={item?.firstDay.toString()}
      className="mx-auto w-[90%] rounded-xl bg-white border border-black mb-5"
    >
      <div
        className={`w-full h-fit flex justify-between bg-blue-100 ${
          daysVisible[weekIndex] ? "rounded-t-xl" : "rounded-xl"
        }`}
      >
        <h2 className="text-2xl font-semibold p-3 items-start">
          {item?.firstDay} to {item?.lastDay}
        </h2>
        <button
          className="my-auto mx-5 cursor-pointer"
          onClick={() => toggleDaysVisibility(weekIndex)}
        >
          {daysVisible[weekIndex] ? (
            <div className="flex space-x-5">
              <p className="text-lg text-blue-400">Close Timesheet</p>
              <ChevronDoubleUpIcon className="h-7 text-black cursor-pointer" />
            </div>
          ) : (
            <div className="flex space-x-5">
              <p className="text-lg text-blue-400">Fill Timesheet</p>
              <ChevronDoubleDownIcon className="h-7 text-black cursor-pointer" />
            </div>
          )}
        </button>
      </div>

      <div className={`${daysVisible[weekIndex] ? "max-h-fit" : "hidden"}`}>
        {datesData.length > 0 ? (
          datesData[weekIndex].map((item,index) => {
            const [day, month, year] = item.split("/");
            const date = new Date(year, month - 1, day);
            const currentDate = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            );
           
             let logDataIndex = timeSheet?.employeeWorkLog?.findIndex(
               (y) => {
                 const formattedDate = new Date(
                   y.fromDate
                 ).toLocaleDateString("en-GB", {
                   day: "2-digit",
                   month: "2-digit",
                   year: "numeric",
                 });
                 return (
                   formattedDate === item || y.fromDate === item.split(".")[0]
                 );
               }
             );
            const reverseDate = (d) => {
              let inputDate = d;
              let date = new Date(inputDate);
              let day = String(date.getDate()).padStart(2, "0");
              let month = String(date.getMonth() + 1).padStart(2, "0");
              let year = date.getFullYear();
              let formattedDate = `${day}/${month}/${year}`;
              return formattedDate;
            };
            const showField = () => {
              const sons = props?.timeSheetDatesData?.filter((each) => {
                const reverseDatee = reverseDate(each.date);
                return item === reverseDatee;
              });
              return sons ? sons[0]?.status : 209;
            };
            const renderOtherData = (code) => {
              switch (code) {
                case 202:
                  return (
                    <p className="text-center font-semibold">Absent on this day</p>
                  );
                case 203:
                  return (
                    <p className="text-center font-semibold">WeekOFF</p>
                  );
                case 204:
                  return (
                    <p className="text-center font-semibold">On leave</p>
                  );
                case 205:
                  return (
                    <p className="text-center font-semibold">Holiday</p>
                  );
                case 207:
                    return (
                    <p className="text-center font-semibold"></p>
                    );
                case 209:
                  return (
                    <p>Record Not Found</p>
                  );
                default:
                  return null;
              }              
            };
            const renderDate = () => {
              const statuss = showField();
              if (statuss === 201 || statuss === 206 || statuss === undefined) {
                return (
                  <>
                    <div>
                      <p className="text-[10px] mb-2">Select Projects:</p>
                      {props.projects?.length > 0 ? (
                        <FormControl className="w-full mt-2">
                          <Select
                            label="Projects"
                            name="projects"
                            className="w-full"
                            inputProps={{ "aria-label": "Without label" }}
                            displayEmpty
                            multiple
                            value={props?.projectId?.[logDataIndex] ?? []}
                            onChange={(e) =>
                              props.handleProjects(e, logDataIndex)
                            }
                            // disabled={isSubmitted}
                            MenuProps={{
                              sx: {
                                "& .MuiList-root": {
                                  maxHeight: 300,
                                },
                                "& .MuiInputBase-root": {
                                  height: 50,
                                },
                              },
                            }}
                            //disabled={isApplied}
                            renderValue={(selected) => {
                              return selected
                                .map((value) => {
                                  const selectedItem = props.projects.find(
                                    (item) =>
                                      item._id === value ||
                                      item.project === value
                                  );
                                  return selectedItem
                                    ? selectedItem.project
                                    : "";
                                })
                                .join(", ");
                            }}
                          >
                            {props.projects.length > 0 &&
                              props.projects.map((x) => {
                                return (
                                  <MenuItem key={x._id} value={x._id}>
                                    <Checkbox
                                      checked={timeSheet?.employeeWorkLog[
                                        logDataIndex
                                      ]?.projectIds?.includes(x._id)}
                                      // Use includes for better readability
                                      onClick={(e) =>
                                        handleProjectChange(
                                          item,
                                          timeSheet,
                                          setTimeSheet,
                                          x._id,
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <ListItemText
                                      primary={x.project}
                                      onClick={() => {
                                        const isCurrentlyChecked =
                                          timeSheet?.employeeWorkLog[
                                            logDataIndex
                                          ]?.projectIds?.includes(x._id);
                                        handleProjectChange(
                                          item,
                                          timeSheet,
                                          setTimeSheet,
                                          x._id,
                                          !isCurrentlyChecked
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    />{" "}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      ) : (
                        "No Project/On Bench"
                      )}
                    </div>
                    <div>
                      <p className="text-[10px]">Enter log hours:</p>
                      <input
                        id={currentDate.toISOString()}
                        placeholder="Enter working hours"
                        className="w-full px-3 py-2 border rounded-sm bg-gray-100"
                        onChange={(e) =>
                          handleHourChange(e, timeSheet, setTimeSheet)
                        }
                        value={getLogHoursValue(
                          currentDate.toISOString(),
                          timeSheet
                        )}
                        type="number"
                      />
                    </div>
                    <div>
                      <p className="text-[10px]">Enter Task:</p>
                      <input
                        id={currentDate.toISOString()}
                        className="w-full px-3 py-2 border rounded-sm bg-gray-100"
                        onChange={(e) =>
                          handleCommentChange(e, timeSheet, setTimeSheet)
                        }
                        value={getCommentsValue(
                          currentDate.toISOString(),
                          timeSheet
                        )}
                        type="text"
                      />
                    </div>
                  </>
                );
              } else {
                return renderOtherData(statuss);
              }
            };
            const renderNonEditbleData = () => {
              const statuss = showField();
              if (statuss === 201 || statuss === 206 || statuss === undefined) {
                return (
                  <>
                    <p className="text-lg my-auto">
                      Projects :{" "}
                      {props?.projectId?.[logDataIndex]?.length > 0
                        ? props?.projectId?.[logDataIndex].join(",")
                        : "-"}
                    </p>
                    <p className="text-lg my-auto">
                      Worked Hours :{" "}
                      {getLogHoursValue(currentDate.toISOString(), timeSheet)}
                    </p>
                    <p className="text-lg my-auto">
                      Tasks :{" "}
                      <Tooltip
                        title={getCommentsValue(
                          currentDate.toISOString(),
                          timeSheet
                        )}
                        arrow
                        placement="top"
                      >
                        <span className="text-sm">
                          {exceedsWordLimit(
                            getCommentsValue(
                              currentDate.toISOString(),
                              timeSheet
                            )
                          )
                            ? getCommentsValue(
                                currentDate.toISOString(),
                                timeSheet
                              ).slice(0, 25) + "..."
                            : getCommentsValue(
                                currentDate.toISOString(),
                                timeSheet
                              ) || "--"}
                        </span>
                      </Tooltip>
                    </p>
                  </>
                );
              } else {
                return renderOtherData(statuss);
              }
            };
            return (
              <div
                key={item}
                className={`grid grid-cols-4 gap-2 col-span-2 px-6 py-5 overflow-hidden border-t-2`}
              >
                <p className="text-xl font-semibold my-auto ">{item}</p>
                {isEditable ? renderDate() : renderNonEditbleData()}
              </div>
            );
          })
        ) : (
          <></>
        )}
        <div
          className={` justify-end my-5 w-[95%] ${isEditable && !isAdmin ? "flex" : "hidden"}`}
        >
          <button
            className="bg-blue-500 hover:bg-white hover:text-blue-500 border border-blue-500 text-white font-bold py-1 px-2 rounded"
            onClick={() => handleSubmit(false)}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeekCard;
